import type { RefrigerationUnitRow, RefrigerationUnitTechnicalRow } from '../../db';
import { trim } from '../repoUtils';
import { normalizeRefrigerationUnitComponents } from './components';
import { normalizeRefrigerationUnitSafety } from './safety';
import type { RefrigerationUnitTechnicalInput } from './types';

export function normalizeRefrigerationUnitTechnical(
  input: RefrigerationUnitTechnicalInput | RefrigerationUnitRow['technical'] | undefined,
  existing: RefrigerationUnitRow['technical'] | undefined
): RefrigerationUnitTechnicalRow {
  const components = normalizeRefrigerationUnitComponents(input?.components, existing?.components);

  const safety = normalizeRefrigerationUnitSafety(input?.safety, existing?.safety);

  const maintenanceContractor = input?.maintenanceContractor
    ? {
        name: trim(input.maintenanceContractor.name),
        notes: trim(input.maintenanceContractor.notes),
      }
    : existing?.maintenanceContractor
      ? {
          name: trim(existing.maintenanceContractor.name),
          notes: trim(existing.maintenanceContractor.notes),
        }
      : undefined;

  const normalizedMaintenance = maintenanceContractor?.name ? maintenanceContractor : undefined;

  return {
    components,
    maintenanceContractor: normalizedMaintenance,
    safety,
    notes: trim(input?.notes ?? existing?.notes),
  } satisfies RefrigerationUnitTechnicalRow;
}
